"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SupplementaryDocumentRoutes = void 0;
const compliance_route_1 = require("./compliance-route");
class SupplementaryDocumentRoutes extends compliance_route_1.ComplianceRoute {
    constructor() {
        super('supplementary_documents');
    }
    getSubmissions() {
        return this.get('/');
    }
    upload(type, url, businessInfoId) {
        return this.post('/', { type, url, businessInfoId });
    }
    getTypes() {
        return this.get('/types');
    }
}
exports.SupplementaryDocumentRoutes = SupplementaryDocumentRoutes;
//# sourceMappingURL=supplementary_document.js.map